<template>
  <tables
    :dataset="_dataset"
    type="screens"
    :queryParams.sync="queryParams"
    :headers="chargedHeaders"
  >
    <template v-slot:content="slotProps">
      <div v-if="showMobileView">
        <v-row>
          <v-col cols="6" class="px-0 pt-0 pb-2">
            <v-card-text class="py-0 text-h6 font-weight-medium">
              {{
                slotProps.data.screen
                  ? slotProps.data.screen.device_id.substring(0, 6)
                  : ""
              }}
            </v-card-text>
          </v-col>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text
              class="text-right py-0 text-subtitle-1 grey--text font-italic"
            >
              {{ slotProps.data.screen.session_status }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider />
        <v-row>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text class="pb-0 pt-2">
              Originating Store
            </v-card-text>
          </v-col>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text
              class="text-right pb-0 pt-2 text-subtitle-2 font-weight-medium"
            >
              <!-- {{ slotProps.data.group.name }} -->
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text class="py-0">
              Charged-Off Date
            </v-card-text>
          </v-col>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text
              class="text-right py-0 text-subtitle-2 font-weight-medium"
            >
              {{ formatDate(slotProps.data.screen.last_activity) }}
            </v-card-text>
          </v-col>
        </v-row>
      </div>
      <div v-if="!showMobileView" style="width:100%;">
        <v-row
          class="d-flex justify-space-between pl-3 pr-3"
          v-if="!showMobileView"
          style="font-size:12px;"
        >
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            <span>{{
              slotProps.data.screen
                ? slotProps.data.screen.device_id.substring(0, 6)
                : ""
            }}</span>
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ slotProps.data.rental_agreement_number }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            <!-- {{ slotProps.data.group.name }} -->
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{
              slotProps.data.destination ? slotProps.data.destination.name : ""
            }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ formatDate(slotProps.data.end_at) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ formatDate(slotProps.data.start_at) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ formatDate(slotProps.data.expected_end_at) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ slotProps.data.trip_type }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ formatDate(slotProps.data.screen.last_activity) }}
          </div>
        </v-row>
      </div>
    </template>
  </tables>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import Tables from '@/components/app/Table';
import FormatDate from '@/mixins/FormatDate';
import { MobileView } from '@/mixins';

export default {
  components: {
    Tables,
  },
  mixins: [MobileView, FormatDate],
  data: () => ({
    chargedHeaders: [
      'Screen',
      'RA#',
      'Originating Store',
      'Destination Location',
      'Checked-Out',
      'Checked-In',
      'Expected Due Date',
      'Trip Type',
      'Charged Off Date',
    ],
  }),
  computed: {
    ...mapGetters({
      _dataset: 'reports/getChargedOffSessions',
      _getQueryParams: 'reports/getQueryParams',
      currentClient: 'account/getCurrentClient',
    }),
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      _setQueryParams: 'reports/setQueryParams',
    }),
  },
};
</script>
